const quiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "quiz",
    items: [
      { id: "q1", question: "Quale giorno viene prima di martedì?", answers: ["lunedi"], image: null },
      { id: "q2", question: "Quale giorno viene prima di venerdì? ", answers: ["giovedi"], image: null },
      { id: "q3", question: "Quale giorno viene dopo mercoledì? ", answers: ["giovedi"], image: null },
      { id: "q4", question: "Sabato e domenica sono il ... ", answers: ["fine settimana"], image: null },
      { id: "q5", question: "Ci sono _____ giorni in una settimana ", answers: ["7", "sette"], image: null },
      { id: "q6", question: "Quale giorno viene prima di martedì?", answers: ["lunedi"], image: null },
      { id: "q7", question: "Quale giorno viene dopo mercoledì? ", answers: ["giovedi"], image: null },
      { id: "q8", question: "Quale giorno viene prima di martedì?", answers: ["lunedi"], image: null },
      { id: "q9", question: "Quale giorno viene dopo mercoledì? ", answers: ["giovedi"], image: null },
      { id: "q10", question: "Quale giorno viene prima di martedì?", answers: ["lunedi"], image: null },
    ],
  },
  botId: "nualang.quiz.0.0.1",
  botName: "quiz",
  description: "quiz_desc",
  difficulty: "ALL",
  learnLang: "italian",
  name: "Bianca",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMi5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-question-circle?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Benvenuto nel quiz
Ospitato da Joanna.

Conosci i giorni della settimana?

Di '"Ciao" a Bianca per iniziare.`,
  voice: "Bianca",
  versionQuestion: "Quante domande vorresti in questo modello?",
};

export default quiz;
